import * as React from 'react';
export const onepasswordSvg = React.forwardRef(function onepasswordSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#1A285F',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M28 16c0-6.627-5.373-12-12-12S4 9.373 4 16c0 6.628 5.373 12 12 12s12-5.372 12-12ZM13.816 9.333c-.095.185-.095.428-.095.913v2.747a.9.9 0 0 0 .016.238c.013.05.036.096.066.138.033.047.08.085.174.162l.695.564c.114.092.17.138.19.194a.218.218 0 0 1 0 .15c-.02.056-.076.102-.19.194l-.695.564a.958.958 0 0 0-.174.162.431.431 0 0 0-.066.138c-.015.056-.015.117-.015.238v6.02c0 .484 0 .726.094.912a.865.865 0 0 0 .378.378c.185.094.428.094.912.094h1.787c.485 0 .728 0 .913-.094a.865.865 0 0 0 .378-.378c.095-.186.095-.428.095-.913v-2.747c0-.121 0-.182-.016-.238a.43.43 0 0 0-.066-.138c-.033-.047-.08-.085-.174-.162l-.695-.564c-.114-.092-.17-.138-.19-.194a.218.218 0 0 1 0-.15c.02-.056.076-.102.19-.194l.695-.564a.942.942 0 0 0 .175-.162.43.43 0 0 0 .065-.138c.015-.056.015-.117.015-.238v-6.02c0-.484 0-.727-.094-.912a.865.865 0 0 0-.378-.378c-.185-.094-.428-.094-.913-.094h-1.787c-.484 0-.727 0-.912.094a.865.865 0 0 0-.378.378Z',
      fill: '#fff',
    }),
  );
});
onepasswordSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var onepassword = {
  category: 'brand',
  colorable: false,
  name: 'onepassword',
  svg: onepasswordSvg,
};
